import React from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import * as Styles from "../../../../pages/modules/assests_new/subForms/styles/allocationSubFormStyles"
const DateInput = (props) => {
  const { value, onChange, name, style } = props.value ;
    const { styles } = defaultStyles;
    // const handleChange = (date) => {
    //   const formatted = date ? date.format("MM/DD/YYYY") : "";
    //   onChange({ target: { name, value: formatted } });
    // };
  
    return (
      <Styles.InputBorder
        style={{
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
          height:"40px",
          // backgroundColor: "#d9d9d9",
          width:'100%',
          height:"40px",
          display:'flex',
          paddingLeft:'1rem',
          marginTop:'0.3rem',
          backgroundColor:'#F6F6F6',
          border:"1px solid #d9d9d9",
          borderRadius:"0.2rem"
        }}
      >
        <Styles.StyledDatePicker
          name={name}
          className="ant-calendar-picker-input ant-input custom-date-picker"
          format="MM/DD/YYYY"
          placeholder={value && value.placeholder || "Select Date"}
          disabled={value && value.disabled || false}
          value={value && value ? moment(value, "MM/DD/YYYY") : null}
          onChange={onChange}
          style={{
            outline: "none",
            border: "none",
            borderRadius: "0.1rem",
            backgroundColor: "#f6f6f6",
            width: "100%",
            height:"42px",
            ...style,
          }}
        />
      </Styles.InputBorder>
    );
  };
  export default DateInput;
 